import { createAsyncThunk } from '@reduxjs/toolkit';
import { billingProcessService, userService } from 'services';

export const getUserInfo = createAsyncThunk('home/getUserInfo', async () => {
  try {
    const { data } = await userService.getUserInfo();
    return data;
  } catch (error) {
    return null;
  }
});

export const getCountInvoice = createAsyncThunk<any, any>('dashboard/getCountInvoice', async (param) => {
  try {
    const conditions = [
      {
        search_value: ['billing', 'issued', 'payment', 'closed'],
        include_null: false,
        id: 'Status',
        exact_match: true,
      },
      {
        search_value: [param.invoice_month],
        include_null: false,
        id: 'invoice_month',
        exact_match: true,
      },
    ];
    const { data } = await billingProcessService.getCountInvoice({
      conditions: conditions,
    });
    return data.totalItems;
  } catch (error) {
    return 0;
  }
});

export const getCountInvoicePreMonth = createAsyncThunk<any, any>(
  'dashboard/getCountInvoicePreMonth',
  async (param) => {
    try {
      const conditions = [
        {
          search_value: ['payment', 'closed'],
          include_null: false,
          id: 'Status',
          exact_match: true,
        },
        {
          search_value: [param.invoice_month],
          include_null: false,
          id: 'invoice_month',
          exact_match: true,
        },
      ];
      const { data } = await billingProcessService.getCountInvoice({
        conditions: conditions,
      });
      return data.totalItems;
    } catch (error) {
      return 0;
    }
  },
);

export const getCaseBillForPaymentMethod = createAsyncThunk<any, string>(
  'dashboard/getCaseBillForPaymentMethod',
  async (param) => {
    try {
      const result = await Promise.all([
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['振替'],
              include_null: false,
              id: 'payment_method',
              exact_match: true,
            },
            {
              search_value: ['billing', 'issued'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['振替'],
              include_null: false,
              id: 'payment_method',
              exact_match: true,
            },
            {
              search_value: ['payment', 'closed'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['振込'],
              include_null: false,
              id: 'payment_method',
              exact_match: true,
            },
            {
              search_value: ['billing', 'issued'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['振込'],
              include_null: false,
              id: 'payment_method',
              exact_match: true,
            },
            {
              search_value: ['payment', 'closed'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['カード'],
              include_null: false,
              id: 'payment_method',
            },
            {
              search_value: ['billing', 'issued'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
        billingProcessService.getCountInvoice({
          conditions: [
            {
              search_value: [param],
              include_null: false,
              id: 'invoice_month',
              exact_match: true,
            },
            {
              search_value: ['カード'],
              include_null: false,
              id: 'payment_method',
            },
            {
              search_value: ['payment', 'closed'],
              include_null: false,
              id: 'Status',
              exact_match: true,
            },
          ],
        }),
      ]);

      return {
        case7No: result[0].data.totalItems,
        case7Has: result[1].data.totalItems,
        case8No: result[2].data.totalItems,
        case8Has: result[3].data.totalItems,
        case9No: result[4].data.totalItems,
        case9Has: result[5].data.totalItems,
      };
    } catch (error) {
      return null;
    }
  },
);

export const getStatusBill = createAsyncThunk('dashboard/thunk/getStatusBill', async () => {
  try {
    const { data } = await billingProcessService.getStatusBill();

    return data;
  } catch (error) {
    return 0;
  }
});

export const updateStatusBill = createAsyncThunk<any, any>('dashboard/thunk/updateStatusBill', async (req) => {
  try {
    const { data } = await billingProcessService.updateStatusBill(req);

    return data;
  } catch (error) {
    return 0;
  }
});
